import React, { useState } from 'react'
import { Box, Menu, MenuItem } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { ActionButton } from '@emerald-works-nova/components'

const UserDropdown = ({
  onClickUploadUsers,
  onClickDeleteUsers,
  onClickUploadPermissions,
  onClickNameIdStart,
  isUploading
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box>
      <ActionButton
        variant='primary'
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        Manage Users
      </ActionButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <MenuItem
          data-test='list-item-upload-users'
          onClick={() => {
            handleClose()
            onClickUploadUsers()
          }}
          disabled={isUploading}
        >
            Upload Users
        </MenuItem>
        <MenuItem
          data-test='list-item-delete-users'
          onClick={() => {
            handleClose()
            onClickDeleteUsers()
          }}
          disabled={isUploading}
        >
            Delete Users
        </MenuItem>
        <MenuItem
          data-test='list-item-upload-permissions'
          onClick={() => {
            handleClose()
            onClickUploadPermissions()
          }}
          disabled={isUploading}
        >
            Upload Permissions
        </MenuItem>
        <MenuItem
          data-test='list-item-upload-name-id-update'
          onClick={() => {
            handleClose()
            onClickNameIdStart()
          }}
          disabled={isUploading}
        >
            Update Attributes
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default UserDropdown
